export const SIMULATED_TRAIL_DISCLOSURE = 'Trails are simulated to protect real wildlife.';
